// src/helpers/settings/orderSeatTags.ts
var OrderOrSeatTagEnum = /* @__PURE__ */ ((OrderOrSeatTagEnum2) => {
  OrderOrSeatTagEnum2["SEAT_ONLY"] = "seatOnly";
  OrderOrSeatTagEnum2["ORDER_ONLY"] = "orderOnly";
  OrderOrSeatTagEnum2["BOTH"] = "both";
  return OrderOrSeatTagEnum2;
})(OrderOrSeatTagEnum || {});
var getOrderOrSeatTagValue = (newValue) => {
  switch (newValue) {
    case "seatOnly" /* SEAT_ONLY */:
      return {
        isOrderTag: false,
        isSeatTag: true,
        orderTagFavorite: false
      };
    case "orderOnly" /* ORDER_ONLY */:
      return {
        isOrderTag: true,
        isSeatTag: false,
        seatTagFavorite: false
      };
    case "both" /* BOTH */:
      return {
        isOrderTag: true,
        isSeatTag: true
      };
    default:
      return {
        isOrderTag: false,
        isSeatTag: false,
        orderTagFavorite: false,
        seatTagFavorite: false
      };
  }
};
var getOrderOrSeatTagString = ({
  isOrderTag,
  isSeatTag
}) => {
  if (isOrderTag && !isSeatTag) {
    return "orderOnly" /* ORDER_ONLY */;
  }
  if (!isOrderTag && isSeatTag) {
    return "seatOnly" /* SEAT_ONLY */;
  }
  if (isOrderTag && isSeatTag) {
    return "both" /* BOTH */;
  }
  return null;
};

export { OrderOrSeatTagEnum, getOrderOrSeatTagString, getOrderOrSeatTagValue };
